import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <h1>KAWILA</h1>
          <p>Hostel & Coffee</p>
        </div>

        <button
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li><button onClick={() => scrollToSection('inicio')}>Inicio</button></li>
          <li><button onClick={() => scrollToSection('sobre-nosotros')}>Sobre Nosotros</button></li>
          <li><button onClick={() => scrollToSection('habitaciones')}>Habitaciones</button></li>
          <li><button onClick={() => scrollToSection('servicios')}>Servicios</button></li>
          <li><button onClick={() => scrollToSection('cafe')}>Cafetería</button></li>
          <li><button onClick={() => scrollToSection('tours')}>Tours</button></li>
          <li><button onClick={() => scrollToSection('ubicacion')}>Ubicación</button></li>
          <li><button onClick={() => scrollToSection('contacto')} className="btn-reservar">Reservar</button></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
